<div class="modal-header container-md" id="modal-header">
  <div class="col-4"></div>
  <div class="col-4">
    <img
      id="modal-memorabid-logo"
      src="/assets/img/memorabid-logo-white.svg"
      alt="MEMORABID"
    />
  </div>
  <div class="col-3"></div>
  <div class="col-1">
    <button
      id="closeButton"
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body">
  @if(loginPage){
  <app-sign-in
    [nextPageRoute]="nextPageRoute"
    (changePage)="changePage()"
    (closeModal)="activeModal.dismiss()"
  ></app-sign-in>
  } @if(!loginPage){
  <app-sign-up
    [nextPageRoute]="nextPageRoute"
    [idEvent]="idEvent"
    (changePage)="changePage()"
  ></app-sign-up>
  }
</div>
